import { gql } from '@apollo/client';

export default gql`
  mutation cancelMembership($membershipId: String!, $cancellationReasonId: String!) {
    cancelMembership(membershipId: $membershipId, cancellationReasonId: $cancellationReasonId)
  }
`;
